import React, { useState, useEffect, useRef } from 'react';
import { TextField, Box, useTheme, Button } from '@mui/material';

interface EditDialogProps {
  text: string;
  onSave: (newText: string) => void;
  onCancel: () => void;
}

const EditDialog: React.FC<EditDialogProps> = ({ text, onSave, onCancel }) => {
  const [editedText, setEditedText] = useState(text);
  const textFieldRef = useRef<HTMLTextAreaElement>(null);
  const theme = useTheme();

  useEffect(() => {
    if (textFieldRef.current) {
      textFieldRef.current.focus();
      textFieldRef.current.select();
    }
  }, []);

  const handleSave = () => {
    onSave(editedText);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSave();
    } else if (e.key === 'Escape') {
      onCancel();
    }
  };

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }}
    >
      <TextField
        inputRef={textFieldRef}
        multiline
        fullWidth
        value={editedText}
        onChange={(e) => setEditedText(e.target.value)}
        onKeyDown={handleKeyDown}
        variant="outlined"
        autoFocus
        size="small"
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: theme.palette.background.default,
            minHeight: '40px',
            padding: '8px 12px',
          },
          '& .MuiInputBase-input': {
            fontSize: '0.875rem',
            lineHeight: '1.43',
          },
        }}
      />
      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
        <Button onClick={onCancel} color="inherit">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default EditDialog;
